import * as React from "react";
import Paginator from ".";
import { GENOMES_PER_PAGE } from "../../utils/constants";

const GenomesTablePaginator = ({
  totalCount,
  page,
  onPageChange,
}: {
  page: number;
  totalCount: number;
  onPageChange: (newPage: number) => void;
}) => {
  const numPages = Math.ceil(totalCount / GENOMES_PER_PAGE);
  return (
    <div>
      <div className="genome-count">
        Displaying {totalCount} Product{totalCount > 1 ? "s" : ""}
      </div>
      <Paginator page={page} numPages={numPages} onPageChange={onPageChange} />
    </div>
  );
};

export default GenomesTablePaginator;
